// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"BlogPostTemplate_wrapper__6J42_","headingHr":"BlogPostTemplate_headingHr__HSIWc","navspacer":"BlogPostTemplate_navspacer__cD_6L","body":"BlogPostTemplate_body__YJqz2"};